import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Workflow, Github, GitlabIcon, Cloud, ExternalLink } from "lucide-react";

const PROVIDER_ICONS = { github: Github, gitlab: GitlabIcon, azure: Cloud };
function ProviderIcon({ id, ...props }) {
  const Icon = PROVIDER_ICONS[id] || Cloud;
  return <Icon {...props} />;
}

export default function Pipelines() {
  const [pipelines, setPipelines] = useState([]);

  useEffect(() => {
    api.get("/pipelines").then((r) => setPipelines(r.data.pipelines)).catch(() => {});
  }, []);

  return (
    <div className="p-8 fadeup">
      <div className="text-xs tracking-[0.2em] uppercase font-bold text-zinc-400 mb-1">Registro</div>
      <h1 className="text-4xl font-black tracking-tighter mb-8">Pipelines</h1>

      {pipelines.length === 0 ? (
        <div className="border border-dashed border-line p-10 text-center text-zinc-400">
          &gt; nenhuma pipeline configurada_
          <div className="mt-4">
            <Link to="/app/repositories" data-testid="empty-go-repos" className="bg-acid text-black font-bold uppercase tracking-widest text-sm px-6 py-3 hover:bg-[#32e612] inline-block">
              Selecionar repositório
            </Link>
          </div>
        </div>
      ) : (
        <div className="border border-line bg-surface">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-line text-xs uppercase tracking-widest text-zinc-400">
                <th className="text-left px-4 py-3 font-medium">Repositório</th>
                <th className="text-left px-4 py-3 font-medium">Provedor</th>
                <th className="text-left px-4 py-3 font-medium">Ferramentas</th>
                <th className="text-left px-4 py-3 font-medium">Status</th>
                <th className="px-4 py-3"></th>
              </tr>
            </thead>
            <tbody>
              {pipelines.map((p) => (
                <tr key={p.id} data-testid={`pipeline-row-${p.id}`} className="border-b border-line last:border-0 hover:bg-white/5 transition-colors">
                  <td className="px-4 py-3 font-bold">{p.repo_full_name}</td>
                  <td className="px-4 py-3">
                    <span className="flex items-center gap-2 text-zinc-400">
                      <ProviderIcon id={p.provider} size={14} /> {p.provider}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-zinc-400">{p.tools.length} ferramentas</td>
                  <td className="px-4 py-3">
                    <span className={`text-xs uppercase tracking-widest border px-2 py-0.5 ${p.status === "committed" ? "border-acid text-acid" : "border-zinc-600 text-zinc-400"}`}>{p.status}</span>
                  </td>
                  <td className="px-4 py-3 text-right">
                    <Link to={`/app/pipelines/${p.id}`} data-testid={`open-pipeline-${p.id}`} className="text-acid hover:underline inline-flex items-center gap-1">
                      abrir <ExternalLink size={12} />
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
